/**
 * index.jsx
 *
 * This is the entry file for the application, only setup and boilerplate
 * code.
 */

import 'core-js/stable';
import 'regenerator-runtime/runtime';

import React from 'react';
import { createRoot } from 'react-dom/client';
import moment from 'moment';
import '@formatjs/intl-pluralrules/polyfill';
import '@formatjs/intl-pluralrules/locale-data/en';
import '@formatjs/intl-pluralrules/locale-data/it';
import MainContainer from './containers/MainContainer';
import store from './store/createStore';

// ========================================================
// Render Setup
// ========================================================
const MOUNT_NODE = document.getElementById('root');
const authRoutes = require('./routes/routes').default(store);
const noauthRoutes = require('./routes/routes').createUnauthRoutes(store);
const root = createRoot(MOUNT_NODE);

// React INTL

moment.locale('it');

let logged = window.sessionStorage.getItem('jwt') === null ? false : true;

if (DEBUG_MODE) {
	// initLogger();
}

if (ISMOCK && !MOCK_LOGIN) {
	logged = true;
	window.sessionStorage.setItem( 'jwt', JSON.stringify(`asc7gdsv0b8s7vg8iubcpugdcs7o8gcioV8SACC.KDSF9SPVASDdsf8sad90fF`) );
}

root.render(<MainContainer store={store} authRoutes={authRoutes} noauthRoutes={noauthRoutes} logged={logged} />);

if (module.hot) {
	module.hot.accept('./routes/routes', () =>
		setImmediate(() => {
			root.render(<MainContainer store={store} authRoutes={authRoutes} noauthRoutes={noauthRoutes} logged={logged} />);
		})
	);
}

if (process.env.NODE_ENV === 'production') {
	if (!window.console) window.console = {};
	const methods = ['log', 'debug', 'warn', 'info', 'error'];
	for (let i = 0; i < methods.length; i += 1) {
		console[methods[i]] = () => {};
	}
	// eslint-disable-next-line global-require
	require('@lcdp/offline-plugin/runtime').install();
}
